module.exports = __webpack_public_path__ + "img/assets/select/violet@2x.f7ba923e788dd927be95d433d23509eb.webp";